import { normalizeDiacriticsAndCase } from '../../../core/utils';

/* eslint-disable */
export default {
  transform: (chunk, { Types, Promise, Mappers, Logger }) =>
    new Promise(resolve => {
      const groupMapper = Mappers('group');
      groupMapper
        .findOne({options: 'user.is.salesRep'})
        .lean()
        .select('_id')
        .exec()
        .then(group => {
          const newObject = { ...chunk };
          if (!newObject.$set) {
            newObject.$set = {};
          }
          newObject.$set.distributor = new Types.ObjectId(newObject.__tmp.dist_id);   //eslint-disable-line
          newObject.$set.dm = new Date();

          const nameChunks = newObject.__tmp.n.split(/\s+/);
          const nameArray = [nameChunks.shift(), nameChunks.join(' ')];
          newObject.$set.firstname = nameArray[0];
          newObject.$set.lastname = nameArray[1];
          newObject.$set.group = group._id;
          newObject.$set.email = newObject.__tmp.email;
          newObject.$set.username = newObject.__tmp.email;

          if (!newObject.$setOnInsert) {
            newObject.$setOnInsert = {};
          }
          newObject.$setOnInsert.firstname_text = normalizeDiacriticsAndCase(
            nameArray[0],
          );
          newObject.$setOnInsert.lastname_text = normalizeDiacriticsAndCase(
            nameArray[1],
          );
          newObject.$setOnInsert.fullname_text = normalizeDiacriticsAndCase(
            `${nameArray[0]} ${nameArray[1]}`,
          );
          newObject.$setOnInsert.e = true;
          newObject.$setOnInsert.dc = new Date();

          // __tmp is used to store temporary data we may need
          delete newObject.__tmp;
          return resolve({ chunk: newObject });
        });
    }),
};



// WEBPACK FOOTER //
// ./src/configs/etl/reps/repsPayloadTransform.js